<template>
    <!-- 类型选择弹框 -->
    <el-dialog
        custom-class="fiscan-kp-selector"
        title="选择违禁品知识点"
        :visible="value"
        width="500px"
        :close-on-click-modal="true"
        :append-to-body="false"
        :modal-append-to-body="false"
        @close="close"
    >
        <div class="knowledge-selector">
            <div class="danger-group" v-for="item in imageDictionary" :key="item.id">
                <h5>{{ item.name }}</h5>
                <div class="danger-items">
                    <el-tag
                        v-for="v in item.children"
                        :key="v.id"
                        @click="currentTagKp = {id: v.id, name: v.name}"
                        :effect="currentTagKp.id === v.id ? 'dark': ''"
                    >
                        {{ v.name }}
                    </el-tag>
                </div>
            </div>

            <div class="btn-footer">
                <el-button type="warning" @click="submitTagKp" size="medium">确定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            currentTagKp: {
                id: 0,
                name: ''
            },
            imageDictionary: [],
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog()
            }
        },
    },

    mounted() {
        const data = {
            isIdentification: true,
            hideNodeIfZero: true  // 是否隐藏无库存知识点
        }

        this.$api.getFiscanImageStock(data).then(res => {
            this.imageDictionary = res.package
        })
    },

    methods: {
        initDialog() {
            this.currentTagKp = {id: 0, name: ''}
        },

        submitTagKp() {
            this.$emit('submit', this.currentTagKp)
            this.close()
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style lang="scss">
.fiscan-kp-selector {

    .knowledge-selector {
        border-radius: 4px;
        .el-dialog__footer {
            padding-bottom: 15px;
        }
    }

    .danger-group {
        h5 {
            margin: 12px 0 0 5px;
            font-size: 14px;
            color: #7a7a7a;
            font-weight: 600;
        }

        .danger-items {
            padding: 5px 0 12px 15px;
        }

        .el-tag {
            margin-top: 15px;
            margin-right: 8px;
            cursor: pointer;
        }
    }

    .btn-footer {
        padding: 0 10px 10px 0;
        text-align: right;
    }
}
</style>
